import { render } from "./HeartBeater.vue?vue&type=template&id=4dd91188&bindings={\"delay\":\"props\",\"timerIsStopped\":\"props\",\"beat\":\"options\"}"
import script from "./HeartBeater.vue?vue&type=script&lang=js"
export * from "./HeartBeater.vue?vue&type=script&lang=js"
script.render = render

export default script